/** @jsxImportSource @emotion/react */
import React from 'react'
import { roleButtonsRowStyle } from '../styles'

export interface RoleButtonsRowProps {
  snacks: React.ReactNode
  videographer: React.ReactNode | null
}

/**
 * Layout wrapper that arranges the Drinks/Snacks and Videographer role buttons.
 * Both present: side-by-side, equal flex. One present: full-width.
 * Each child should already render its own label-above + container shape.
 */
const RoleButtonsRow: React.FC<RoleButtonsRowProps> = ({
  snacks,
  videographer,
}) => {
  if (!snacks && !videographer) {
    return null
  }
  return (
    <div css={roleButtonsRowStyle}>
      {snacks}
      {videographer}
    </div>
  )
}

export default React.memo(RoleButtonsRow)
